/* Pelux · Taille à choisir — réglage « Aucune taille cochée à l'arrivée » du bloc Variantes.
 *
 * Revue complète du 2026-09-25 (R8) : sur le harnais, la taille S était cochée d'office et le
 * bouton principal l'ajoutait sans qu'on l'ait choisie, alors que la fiche dit « Entre deux
 * tailles ? Prends la plus grande » et qu'une mauvaise taille coûte un second harnais expédié.
 *
 * Le Liquid (sections/main-product.liquid → product-variant-picker, buy-buttons) rend la page
 * sans taille cochée, bouton « Choisis sa taille », paiement express masqué. Ce script tient
 * cet état jusqu'au choix du client :
 *   1. product-info.js re-rend tout le <variant-selects> à chaque changement de couleur, et
 *      Shopify y coche la 1re taille disponible (option_values incomplet) → on la décoche dans
 *      le HTML reçu, avant insertion (addPreProcessCallback : aucun clignotement) ;
 *   2. à la fin de chaque mise à jour, product-info.js remet « Ajouter au panier » et pose
 *      ?variant= dans l'URL (un rechargement cocherait la taille) → on rétablit l'un, on retire
 *      l'autre ;
 *   3. « Ajouter au panier » et « Ajouter le duo » (pelux-pack.js) enverraient la variante du
 *      champ caché → on les arrête et on ramène au choix de la taille.
 *
 * ⚠️ Le champ caché [name="id"] garde une variante de la COULEUR choisie (1re taille) : la barre
 * collante, le CTA final et le duo y lisent la couleur. Ne jamais le vider.
 * ⚠️ Une fois la taille choisie, plus rien n'intervient : Dawn reprend la main.
 * Chargé par sections/main-product.liquid, APRÈS product-info.js et product-form.js.
 */
(function () {
  // Textes : window.peluxStrings (layout/theme.liquid, locales/<langue>.json) ; repli en français.
  const TEXTES = window.peluxStrings || {};
  const MESSAGE = TEXTES.tailleAbord || 'Choisis d’abord sa taille.';

  function brancher(info) {
    // ⚠️ État rangé sous data-pelux-taille-etat, jamais data-pelux-taille : ce nom-là marque le
    // <fieldset> de la taille, et un ancêtre qui le porterait ferait passer la couleur pour une taille.
    if (info.dataset.peluxTailleEtat) return;
    if (!info.querySelector('variant-selects[data-pelux-taille-requise]')) return;
    if (typeof info.addPreProcessCallback !== 'function') return;

    const section = info.dataset.section;
    const formId = 'product-form-' + section;
    // ⚠️ Jamais form.id : le formulaire contient un champ nommé « id », que form.id renvoie.
    const form = document.getElementById(formId);
    const productForm = form ? form.closest('product-form') : null;
    if (!productForm) return;

    let choisie = !!info.querySelector('variant-selects fieldset[data-pelux-taille] input:checked');
    info.dataset.peluxTailleEtat = choisie ? 'choisie' : 'a-choisir';
    // Arrivée par un lien ?variant= : la taille est celle du lien, rien à tenir.
    if (choisie) return;

    const bouton = productForm.querySelector('[type="submit"][name="add"]');
    const texte = bouton ? bouton.querySelector('span') : null;
    const libelle = (texte && texte.textContent.trim()) || TEXTES.choisisSaTaille || 'Choisis sa taille';
    const champ = () => info.querySelector('variant-selects fieldset[data-pelux-taille]');

    const tenir = () => {
      productForm.classList.add('pelux-taille-a-choisir');
      if (bouton) bouton.removeAttribute('disabled');
      if (texte) texte.textContent = libelle;
    };

    const appeler = () => {
      const c = champ();
      if (!c) return;
      const aide = c.querySelector('[data-pelux-taille-aide]');
      if (aide) aide.textContent = MESSAGE;
      c.classList.remove('is-attention');
      void c.offsetWidth; // relance l'animation d'appel
      c.classList.add('is-attention');
      const r = c.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) {
        c.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      const premiere =
        c.querySelector('input[type="radio"]:not(.disabled)') || c.querySelector('input[type="radio"]');
      if (premiere) premiere.focus({ preventScroll: true });
    };

    // 1. HTML re-rendu (changement de couleur) : la taille reste décochée tant qu'elle n'est
    //    pas choisie.
    info.addPreProcessCallback((html) => {
      if (choisie || !html || !html.querySelectorAll) return;
      html.querySelectorAll('fieldset[data-pelux-taille] input[type="radio"]').forEach((input) => {
        input.removeAttribute('checked');
        input.checked = false;
      });
    });

    // 2. Le client coche une taille. Écoute sur <product-info> : le <variant-selects> est
    //    remplacé à chaque mise à jour.
    info.addEventListener(
      'change',
      (e) => {
        const t = e.target;
        if (choisie || !t || !t.matches || !t.matches('fieldset[data-pelux-taille] input[type="radio"]')) return;
        choisie = true;
        info.dataset.peluxTailleEtat = 'choisie';
        productForm.classList.remove('pelux-taille-a-choisir');
        const aide = t.closest('fieldset[data-pelux-taille]').querySelector('[data-pelux-taille-aide]');
        if (aide) aide.textContent = '';
        // Le libellé : product-info.js remet « Ajouter au panier » à la fin de la mise à jour.
      },
      true
    );

    // 3. Fin de chaque mise à jour (changement de couleur sans taille) : l'état tient, et l'URL
    //    ne garde pas ?variant=.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
        if (choisie || !evt || !evt.data) return;
        if (evt.data.sectionId !== (info.dataset.originalSection || section)) return;
        tenir();
        if (info.dataset.updateUrl !== 'false' && /[?&]variant=/.test(window.location.search)) {
          window.history.replaceState({}, '', window.location.pathname);
        }
      });
    }

    // 4. Garde : « Ajouter au panier ». Capture sur document : passe avant product-form.js,
    //    qui écoute l'envoi sur le formulaire lui-même.
    document.addEventListener(
      'submit',
      (e) => {
        if (choisie || e.target !== form) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        appeler();
      },
      true
    );

    // 5. Garde : « Ajouter le duo » (pelux-pack.js ajoute la variante du formulaire principal).
    document.addEventListener(
      'click',
      (e) => {
        if (choisie) return;
        const b = e.target && e.target.closest ? e.target.closest('[data-pack-add]') : null;
        const pack = b ? b.closest('pelux-pack') : null;
        if (!pack || pack.dataset.formId !== formId) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        appeler();
      },
      true
    );

    tenir();
  }

  document.querySelectorAll('product-info').forEach(brancher);
})();
